<template>
  <div class="yoyo-container mx-auto min-h-screen pb-4 pb-[env(safe-area-inset-bottom)] bg-gray-50">
    <!-- 导航栏 -->
    <navBar :title="$t('products.reviews')" />

    <!-- 用户评价列表 -->
    <div class="w-[calc(100%-2rem)] mx-auto">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="reviews.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('query.noMoreData')"
          :loading-text="$t('query.loading')"
          @load="onLoad">
          <!-- 无数据提示 -->
          <div v-if="!reviews.length && !loading" class="text-center text-gray-500 py-8">
            {{ $t("common.noData") }}
          </div>

          <!-- 评价列表 -->
          <div v-else class="bg-white rounded-lg py-3 px-4">
            <div v-for="review in reviews" :key="review.id" class="last:mb-0">
              <!-- 用户信息 -->
              <div class="flex items-center mb-2">
                <!-- <img
                  :src="imageBaseUrl + review.countryIcon"
                  class="w-6 h-6 rounded-full mr-2 border border-gray-200"
                  alt=""
                /> -->
                <div class="w-6 h-6 rounded-full mr-2 text-xs bg-orange-300 text-white leading-6 text-center align-middle">
                  {{ firstLetter(review.userNickname) }}
                </div>
                <span class="text-sm font-medium">{{ review.userNickname }}</span>
                <van-rate v-model="review.scores" readonly size="12" color="#ffd21e" void-color="#eee" class="ml-2" />
              </div>

              <!-- 评价内容 -->
              <div class="text-sm text-gray-700 mb-2 leading-relaxed">
                <!-- <span v-if="review.content && review.content.length > 20">
                  {{ review.isExpanded ? review.content : review.content.substring(0, 20) + '...' }}
                </span> -->
                <div>
                  <div class="text-sm text-gray-700 mb-1 leading-relaxed">{{ review.content }}</div>
                  <div class="text-xs text-gray-400 mt-1">{{ formatDate(review.createTime) }}</div>
                </div>
              </div>

              <!-- 展开/收起按钮 -->
              <!-- <div v-if="review.content && review.content.length > 20" class="mb-2 flex items-center justify-between">
                <div class="text-xs text-[#ff7a00]" @click="toggleReview(review)">
                  {{ review.isExpanded ? $t('products.showLess') : $t('products.showMore') }}
                </div>
                <div class="text-xs text-gray-400">{{ formatDate(review.createTime) }}</div>
              </div> -->

              <!-- 分割线 -->
              <van-divider v-if="review.id !== reviews[reviews.length - 1].id" />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <van-empty v-if="reviews.length === 0" :description="$t('common.noData')" />
    </div>
  </div>
</template>

<script>
import { PullRefresh, List, Rate, Divider, Empty } from "vant"
import dayjs from "dayjs"
import { mapGetters } from "vuex"
import { getProductReview } from "@/apis/shop"

export default {
  name: "ProductReviewsList",
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Rate.name]: Rate,
    [Divider.name]: Divider,
    [Empty.name]: Empty,
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
    }),
    imageBaseUrl() {
      return process.env.VUE_APP_IMAGE_URL
    },
  },
  data() {
    return {
      reviews: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
    }
  },
  methods: {
    formatDate(ts) {
      return dayjs(ts).format("YYYY-MM-DD")
    },
    toggleReview(review) {
      this.$set(review, "isExpanded", !review.isExpanded)
    },
    onRefresh() {
      this.pageNo = 1
      this.finished = false
      this.reviews = []
      this.fetchReviews()
    },
    onLoad() {
      this.fetchReviews()
    },
    async fetchReviews() {
      // spuId 优先从 query.spuId 取，兼容 query.id
      const spuId = this.$route.query.id
      if (!spuId) {
        this.loading = false
        this.refreshing = false
        return
      }

      if (this.finished) return

      this.loading = true
      try {
        const params = {
          spuId,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        const res = await getProductReview(params)
        const data = res.data || {}
        const list = data.list || []
        const total = data.total || 0

        if (this.refreshing) {
          this.reviews = list
          this.refreshing = false
        } else {
          this.reviews = [...this.reviews, ...list]
        }

        this.total = total
        this.loading = false

        // 根据 total 判断是否加载完
        if (this.reviews.length >= this.total || !list.length) {
          this.finished = true
        } else {
          this.pageNo++
        }
      } catch (e) {
        this.loading = false
        this.refreshing = false
      }
    },
    firstLetter(name) {
      const firstLetter = name.slice(0, 1).toUpperCase()
      console.log("firstLetter :>> ", firstLetter)
      return firstLetter
    },
  },
  created() {
    this.fetchReviews()
  },
}
</script>

<style scoped></style>
